// extracted by mini-css-extract-plugin
export default {"wrapper":"_OUvwgc_xjVC2F2ucFQs","measurer":"mLnsFPqwTIFNmFGGHzxS","show-less":"zzLPFMtbmBN6EqFUMO6C","show-more":"zQAa1Fo8rcqHbAsPByPy","button":"nIjt3DV_iWcPGdGogmh2"};